import type { OrderDiscountTierT } from './types';

/**
 * Cart threshold discounts, in minor units of the store's own currency — the
 * same figures apply in every market ($2,000 / £2,000 / 2 000 €).
 *
 * Product owns these numbers; keeping them here means a tier change is a
 * one-line edit rather than a hunt through components. Must stay sorted by
 * threshold, ascending.
 */
export const ORDER_DISCOUNT_TIERS: OrderDiscountTierT[] = [
  { percentage: 3, threshold: 200_000 },
  { percentage: 5, threshold: 500_000 },
];

/**
 * Cart subtotal from which the progress badge appears. Below it the shopper is
 * too far from the first tier for the nudge to be useful.
 */
export const ORDER_DISCOUNT_BADGE_FLOOR = 150_000;
